import React from 'react';
import { Tooltip } from '@material-ui/core';
import MessageIcon from '@material-ui/icons/Message';
import AirbnbIcon from '../../custom_icons/airbnb.svg';
import './Book.scss';

const Book = () => {

	const handleAirbnbLink = () => {
		window.open('https://airbnb.com/h/flvacationhouse');
	}

	return (
		<div className="fab-container">
			<Tooltip className="tooltip" arrow title="*No booking fees">
			<button className="fab-button">
				<span className="fab-animation">
					<span className="fab-content-wrapper">
						<span className="fab-icon"><MessageIcon /></span>
						<span className="fab-text">Inquire Now</span>
					</span>
				</span>
			</button>
			</Tooltip>
			<Tooltip title="*Additional booking fees">
			<button className="fab-button" onClick={handleAirbnbLink}>
				<span className="fab-animation">
					<span className="fab-content-wrapper">
						<span className="fab-icon"><img src={AirbnbIcon} alt="Airbnb Icon" /></span>
						<span className="fab-text airbnb">airbnb</span>
					</span>
				</span>
			</button>
			</Tooltip>
	  	</div>
	);
}

export default Book;